export { default as theme } from 'prism-themes/themes/prism-xonokai.css';
